import select from './select'
import selectImage from './select-image'
import sliderScroller from './slider-scroller'
import binary from './binary'
import radio from './radio'
import star from './star'
import common from './common'

/**
 * Returns answers responses by question options wise,
 * taking into account question `type`
 *
 * @export
 * @param {*} answers
 * @param {*} question
 * @returns
 */
export default function (answers, question, filteredRecords) {
    switch(question.type) {
        case 'select':
            return select(answers, question)
        case 'box_select':
        case 'small_image_select':
        case 'large_image_select':
            return selectImage(answers, question)
        case 'slider':
        case 'scroller':
            return sliderScroller(answers, question)
        case 'binary':
            return binary(answers, question)
        case 'radio':
            return radio(answers, question)
        case 'star':
            return star(answers, question)
        case 'long_text_bubble':
            return question.options.map((option) => ({
                key: option.id,
                name: option.display_text,
                user: answers.filter((answer) => answer.value.some(({id}) => id === option.id))
            }))
        case 'text':
        case 'image_upload':
        case 'unit':
        case 'date':
            return common(answers, question)
        case 'multi_question':
            return question.questions.map((currQuestion) => {
                const questionAnswered = answers
                    .map((ans) => {
                        return {
                            ...ans,
                            value: ans.value.find(({ id }) => id === currQuestion.id)
                        }
                    })
                    .filter((ans) => ans.value)
                const questionUnanswered = (filteredRecords || [])
                    .filter((ans) => !ans.question.some((qAns) => qAns && qAns.id === question.id))
                    .map((ans) => {
                        return {
                            ...ans,
                            value: ans.question.find(((qAns) => qAns && qAns.id === question.id))
                        }
                    })
                const subQuestionUnanswered = answers
                    .filter((ans) => !ans.value.some(({ id }) => id === currQuestion.id))
                    .map((ans) => {
                        return {
                            ...ans,
                            value: ans.value.find(({ id }) => id === currQuestion.id)
                        }
                    })

                return {
                    key: currQuestion.id,
                    id: currQuestion.id,
                    name: currQuestion.title || currQuestion.question,
                    answer: [
                        {
                            key: '0',
                            name: 'Answered',
                            user: questionAnswered
                        },
                        {
                            key: '1',
                            name: 'unanswered',
                            user: [...questionUnanswered, ...subQuestionUnanswered]
                        }
                    ],
                    event: {}
                }
            })
    }
}
